/**
 * api映射处理，包含权限配置
 */

import server from './base';

//
const { ORDER_BASE_URL, MALL_ORDER_PAY_URL } = server;

// 购物车相关
const newOrder = {
  '/noRight/api/fe/pay/list-pay-way': {
    method: 'GET',
    action: '/noRight/api/fe/pay/list-pay-way',
    baseURL: ORDER_BASE_URL
  },
  '/api/fe/pay/bill-check-out': {
    method: 'POST',
    action: '/api/fe/pay/bill-check-out',
    baseURL: MALL_ORDER_PAY_URL
  },
  '/api/fe/pay/get-token-for-bill-check-out': {
    method: 'POST',
    action: '/api/fe/pay/get-token-for-bill-check-out',
    baseURL: MALL_ORDER_PAY_URL
  },
  '/noRight/api/fe/pay/bill-check-out-by-token': {
    method: 'GET',
    action: '/noRight/api/fe/pay/bill-check-out-by-token',
    baseURL: MALL_ORDER_PAY_URL
  },
  '/api/fe/pay/get-order-pay-or-create': {
    method: 'POST',
    action: '/api/fe/pay/get-order-pay-or-create',
    baseURL: MALL_ORDER_PAY_URL
  },
  '/api/fe/orderInvoice/findInvoice': {
    method: 'GET',
    action: '/api/fe/orderInvoice/findInvoice',
    baseURL: MALL_ORDER_PAY_URL
  },
  '/api/fe/orderInvoice/writeReceipt': {
    method: 'POST',
    action: '/api/fe/orderInvoice/writeReceipt',
    baseURL: MALL_ORDER_PAY_URL
  }
};

export default newOrder;
